export default "__VITE_ASSET__BCbXJrVu__"